module.exports = __webpack_public_path__ + "img/icon-authorization.b781b1c2.svg";